import React from 'react';
import SingleVendorBreadcrumbs from '../shared/SingleVendorBreadcrumbs';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';

const AgreementVendorBreadcrumbs = () => {
  return (
    <SingleVendorBreadcrumbs>
      <BreadcrumbItem>Agreement</BreadcrumbItem>
    </SingleVendorBreadcrumbs>
  );
};

export default AgreementVendorBreadcrumbs;
